import React from 'react';
import './App.css';
import About from '../src/Containers/About';
import Contact from '../src/Containers/Contact';
import Header from "./Containers/Header";
import Navigation from "./Containers/Navigation";
import Services from "./Containers/Services";
import Gallery from "./Containers/Gallery";
import JsonData from './data/data.json';
// import Team from "./Containers/Team";

class App extends React.Component {

    state = {
        landingPageData: {},
    }
    getlandingPageData() {
        this.setState({landingPageData : JsonData})
    }

    componentDidMount() {
        this.getlandingPageData();
    }
    render() {
        return (
            <>
                <Navigation />
                <Header data={this.state.landingPageData.Header} />
                <About data={this.state.landingPageData.About}/>
                <Services data={this.state.landingPageData.Services} />
                <Gallery />
                {/*<Team data={this.state.landingPageData.Team} />*/}
                <Contact  data={this.state.landingPageData.Contact}/>
            </>
        );
    }
}

export default App;
